import { GetterTree } from 'vuex';
import rootStateStore, { State } from './apmCommonState.store';

const getters: GetterTree<State, State> = {
  getServices: state => {
    return state.services;
  },
  getDatabaseServices: state => {
    return state.databaseServices;
  },
  getInstances: state => {
    return state.instances;
  },
  getEndpoints: state => {
    return state.endpoints;
  },
  getCurrentApmService: state => {
    return state.currentService;
  },
  getSubtype: state => {
    return state.subtype;
  }
};
export default getters;
